export const BREADCRUMB_ALTERNATIVE = 'BREADCRUMB_ALTERNATIVE';

export default (betaFeatures) => betaFeatures && betaFeatures.includes(BREADCRUMB_ALTERNATIVE);
